import { render, staticRenderFns } from "./KnowledgeBaseCorrectionPage.vue?vue&type=template&id=c1dd11a8&scoped=true"
import script from "./KnowledgeBaseCorrectionPage.vue?vue&type=script&lang=ts"
export * from "./KnowledgeBaseCorrectionPage.vue?vue&type=script&lang=ts"
import style0 from "./KnowledgeBaseCorrectionPage.vue?vue&type=style&index=0&id=c1dd11a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dd11a8",
  null
  
)

export default component.exports